import { ChatConfigurator } from "../../Shared/Framework/ChatConfigurator";
import { AIExtensionDataSource } from "../../Shared/Framework/AIExtensionDataSource";
import { AIConversationSummaryDecorator } from "./AIConversationSummaryDecorator";
import { AIConversationSummaryConfiguration } from "@cometchat/uikit-shared";

export class AIConversationSummaryExtension extends AIExtensionDataSource {
  private configuration?: AIConversationSummaryConfiguration;

  constructor(configuration?: AIConversationSummaryConfiguration) {
    super();
    this.configuration = configuration;
  }

  override addExtension(): void {
    ChatConfigurator.enable((dataSource: any) => new AIConversationSummaryDecorator(dataSource, this.configuration));
  }

  override getExtensionId(): string {
    return "conversation-summary";
  }
}